<section>
  <mat-form-field [formGroup]="group" class="input-container">
    <input
      matInput
      [formControl]="control"
      [placeholder]="placeHolder"
      [type]="hide ? 'password' : 'text'"
      (input)="checkError()">
    <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
    <mat-icon>{{ hide ? 'visibility_off' : 'visibility'}}</mat-icon>
    </button>
    <mat-error *ngIf="control.hasError('required') && control.touched">{{fieldRequired}}</mat-error>
    <mat-error *ngIf="control.hasError('minlength') && control.touched">{{errorMessage.minlength}}</mat-error>
    <mat-error *ngIf="control.hasError('maxlength') && control.touched">{{errorMessage.maxlength}}</mat-error>
  </mat-form-field>
</section>
